import { WwWorkType } from '@/configs/enums/commons';

export default [
  {
    path: '/admin/workflow/workflow-template/index',
    name: 'M020059',
    component: () =>
      import('@/views/admin/workflow/workflow-template/TemplateIndex.vue'),
    meta: { layout: 'admin' },
  },

  {
    path: '/admin/workflow/flow/list',
    name: 'M020063',
    component: () =>
      import('@/views/admin/workflow/workflow-template/flows/FlowList.vue'),
    meta: { layout: 'admin' },
  },

  {
    path: '/admin/workflow/flow/opr-list',
    name: 'M020064',
    component: () =>
      import('@/views/admin/workflow/workflow-template/flows/Todo.vue'),
    meta: { layout: 'admin', title: '审批记录' },
  },
  {
    path: '/admin/workflow/flow/managed-list',
    name: 'M020067',
    component: () =>
      import('@/views/admin/workflow/workflow-template/flows/ManagedFlow.vue'),
    meta: {
      layout: 'admin',
      dataAuth: {
        bizCode: 'workflow_template',
        operationCode: 'query',
      },
      targetName: '流程统计',
    },
  },
  {
    path: '/admin/workflow/flow/leave-list',
    name: 'M020068',
    component: () =>
      import('@/views/admin/workflow/workflow-template/flows/LeaveFlow.vue'),
    meta: {
      layout: 'admin',
      targetName: '请假统计',
    },
  },

  {
    path: '/workflow/flow/task',
    name: 'taskUiPc',
    component: () =>
      import('@/views/admin/workflow/workflow-template/components/flyflow/components/task/handler/taskUiPcForMessage.vue'),
    meta: {
      layout: 'front',
      redirectType: WwWorkType.工作流消息, // 跳转类型（用于当在企业微信环境下直接访问本页面时，路由自动判断处理成对应的跳转类型）
    },
  },
];
